import Cookies from 'js-cookie';
import { handleWindow } from '@/utils';
const win = handleWindow();
export const M_NAVBAR_HEIGHT = 44; // px
export const API_BASE_URL = '/api';
export const API_HOST = process.env.API_HOST;

const query = win.location.href.split('?')[1];
let ua = win.navigator.userAgent || '';
ua = ua ? ua.toLowerCase() : '';

export const IS_PILOT = /DJI-App-pilot/i.test(ua) || /DJI-App-pilot/i.test(query);
export const IS_DJI_APP = /DJI-App-/i.test(ua) || /DJI-App-/i.test(query);
export const IS_LIGHT = /DJI-App-light/i.test(ua) || /DJI-App-light/i.test(query);
export const IS_MIMO = /dji-(app-)?mimo/i.test(ua) || /dji-(app-)?mimo/i.test(query);
export const IS_WECHAT = /micromessenger/i.test(ua);
export const IS_IOS = /(iphone|ipad|ipod|ios|mac)/i.test(ua);
export const IS_MQQBROWSER = /mqqbrowser/i.test(ua);
export const IS_WEIBO = /weibo/i.test(ua);
export const IS_PRODUCTION = win.location.host.indexOf('dji.com') > -1;

export const LIGHT_DOWNLOAD_IOS = process.env.LIGHT_DOWNLOAD_IOS;
export const LIGHT_DOWNLOAD_ANDROID = process.env.LIGHT_DOWNLOAD_ANDROID;

export const DEFAULT_TITLE = '畅片 - 畅快剪辑 即可出片';

export const isChina =  Cookies.get('server-location') === 'cn';
